module.exports = __webpack_public_path__ + "img/红包.68e2dc33.png";